export enum GroupTypeId {
    Company = 1,
    Bachelor = 2,
    Friends = 3,
    Children = 4,
    GiftCard = 5,
}
